import { isString } from "lodash-es";

interface IFormatterFields {
  firstName: any;
  lastName: any;
}

export const formatFullName = <P extends IFormatterFields>(user?: P | Partial<P> | null) => {
  if (!user) {
    return "";
  }

  const { firstName, lastName } = user;

  return [firstName, lastName]
    .filter(n => isString(n) && n.length)
    .map(n => (n as string).trim())
    .join(" ");
};
